import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Order from './Order';

function App() {
  return (
    <Router>
      {/* <nav style={{ padding: 16 }}>
        <Link to="/">首页</Link> | <Link to="/Order">订单</Link>
      </nav> */}
      <Routes>
        <Route path="/" element={<div style={{padding: 32}}>首页内容</div>} />
        <Route path="/Order" element={<Order />} />
      </Routes>
    </Router>
  );
}

export default App;
